<template>
  <div>
    <basic-container>
      <el-form ref="searchFormRef" :model="selectForm" label-width="80px" v-show="searchBoxFlag">
        <el-row :gutter="24">
          <el-col :span="6">
            <el-form-item label="项目名称" prop="projectId">
              <el-select v-model="selectForm.projectId" placeholder="项目名称" style="width:100%">
                <el-option
                  v-for="item in projectList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="标准名称" prop="name">
              <el-input
                clearable
                placeholder="标准名称"
                v-model="selectForm.name"
                maxlength="20"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="状态" prop="name">
              <el-select
                clearable
                v-model="selectForm.status"
                placeholder="状态"
                style="width:100%"
              >
                <el-option
                  v-for="item in statusList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <div style="float:right">
              <el-button type="primary" icon="el-icon-search" @click="search" size="small">
                搜索
              </el-button>
              <el-button icon="el-icon-delete" @click="searchClear" size="small"> 清空 </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <avue-crud
        :option="option"
        :table-loading="loading"
        :data="standardList"
        :page.sync="page"
        ref="crud"
        @on-load="onLoad"
        @current-change="currentChange"
        @search-reset="searchReset"
        @selection-change="selectionChange"
        @size-change="sizeChange"
        @refresh-change="onLoad"
      >
        <template slot="menuLeft">
          <el-button type="primary" icon="el-icon-plus" size="small" @click="addRecord">
            新 增</el-button
          >
        </template>
        <template slot="menuRight">
          <searchFromShow
            :searchBoxFlag.sync="searchBoxFlag"
            :removeHeight="searchHeight"
            :option="option"
            :refOption="$refs.crud"
          ></searchFromShow>
        </template>
        <template slot-scope="scope" slot="menu">
          <el-button type="text" size="small" icon="el-icon-view" @click="checkStandard(scope.row)"
            >查看
          </el-button>
          <el-button
            type="text"
            size="small"
            icon="el-icon-edit"
            v-if="scope.row.status == 1"
            @click="updateStandard(scope.row)"
            >编辑
          </el-button>
          <el-button
            type="text"
            size="small"
            icon="el-icon-video-play"
            v-if="scope.row.status == 1"
            @click="forbidStandard(scope.row)"
            >停用
          </el-button>
          <el-button
            type="text"
            size="small"
            icon="el-icon-delete"
            v-if="scope.row.lifecycleIndex != 3 && scope.row.lifecycleIndex != 5"
            @click="removeStandard(scope.row.id)"
            >删除
          </el-button>
          <el-button type="text" size="small" icon="el-icon-edit" @click="copyStandard(scope.row)"
            >复制
          </el-button>
          <el-button type="text" size="small" icon="el-icon-link" @click="relateDevice(scope.row)"
            >关联设备
          </el-button>
        </template>
      </avue-crud>
    </basic-container>

    <!-- 新增 -->
    <hr-dialog
      title="新增标准"
      :visible.sync="addDialogVisable"
      :handleClose="handleClose"
      width="65%"
    >
      <template slot="body">
        <el-form ref="addRef" :rules="addStandardRules" :model="form" label-width="80px">
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="项目名称" prop="projectId">
                <el-select
                  v-model="form.projectId"
                  placeholder="请选择 项目名称"
                  style="width:100%"
                  @change="projectIdChange"
                >
                  <el-option
                    v-for="item in projectList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="标准名称" prop="name">
                <el-input v-model="form.name" placeholder="请输入 标准名称" maxlength="20" show-word-limit clearable></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="可选操作" prop="optionalOperationsList">
                <el-select
                  v-model="form.optionalOperationsList"
                  placeholder="请选择 可选操作"
                  style="width:100%"
                  multiple
                >
                  <el-option
                    v-for="item in watchOperateList"
                    :key="item.dictKey"
                    :label="item.dictValue"
                    :value="item.dictKey"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <h6>
                巡检标准（单选）
              </h6>
            </el-col>
            <el-col :span="24">
              <el-form-item  prop="standard">
                <el-input type="textarea" placeholder="请输入 标准标准" v-model="form.standard" rows="6"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <h6>
                巡检标准（填写）
                <el-button type="primary" icon="el-icon-plus" size="small" @click="addInspect">
                  新 增</el-button
                >
              </h6>
            </el-col>
            <el-col :span="24">
              <el-form-item prop="InspectionStatus">
                <el-table :data="form.deviceInspectStandardReadings" border style="width: 100%" max-height='500px'>
                  <el-table-column type="index" label="序号" width="50" align="center"> </el-table-column>
                  <el-table-column prop="name" label="巡检项名称"> </el-table-column>
                  <el-table-column prop="valueRangeMin" label="参考下限"> </el-table-column>
                  <el-table-column prop="valueRangeMax" label="参考上限"> </el-table-column>
                  <el-table-column prop="valueDefault" label="参考标准"> </el-table-column>
                  <el-table-column label="操作" align="center" width="150">
                    <template slot-scope="scope">
                      <el-button
                        type="text"
                        size="small"
                        icon="el-icon-edit"
                        @click="editInspectItem(scope)"
                        >编辑
                      </el-button>
                      <el-button
                        type="text"
                        size="small"
                        icon="el-icon-delete"

                        @click="removeInspectItem(form.deviceInspectStandardReadings,scope)"
                        >删除
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="备注" prop="description">
                <el-input type="textarea" placeholder="请输入 备注" v-model="form.description" maxlength="200"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <div style="float:right">
                <el-button
                size="small"
                  type="primary"
                  @click="AddSubmitStandard"
                  style="margin-right: 20px"
                  icon="el-icon-circle-plus-outline"
                  >保存</el-button
                >
                <el-button size="small" icon="el-icon-circle-close" @click="closeSubmitStandard">取消</el-button>
                <!-- <el-button type="primary" @click="AddSubmitStandard" style="margin-right: 20px"  >确定</el-button>
                            <el-button @click="closeSubmitStandard">取消</el-button> -->
              </div>
            </el-col>
          </el-row>
        </el-form>
        <addInspectItem
          v-if="addInspectItemDialog"
          :operatorModle='inspectItemModle'
          :visible.sync="addInspectItemDialog"
          :dataList.sync="form.deviceInspectStandardReadings"
          :row="inspectItemListRow"
          @getInpectItem="getInpectItem"
        />
      </template>
    </hr-dialog>
    <!-- 查看 -->

    <hr-dialog
      v-if="watchDialogVisable"
      :visible.sync="watchDialogVisable"
      operatorModel='view'
      width="65%"
      title="查看标准"
      :handleClose="handleClose"
    >
      <template slot="body">
        <el-form :model="form" label-width="80px">
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="项目名称" prop="projectId">
                <el-select
                  disabled
                  v-model="watchFrom.projectId"
                  placeholder="请选择"
                  style="width:100%"
                  @change="projectIdChange"

                >
                  <el-option
                    v-for="item in projectList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="标准名称" prop="code">
                <el-input disabled v-model="watchFrom.name"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="可选操作" prop="name">
                <el-select
                  disabled
                  v-model="watchFrom.optionalOperations"
                  placeholder="请选择"
                  style="width:100%"
                  multiple
                >
                  <el-option
                    v-for="item in watchOperateList"
                    :key="item.dictKey"
                    :label="item.dictValue"
                    :value="item.dictKey"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="创建人" prop="code">
                <el-input v-model="watchFrom.realName" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="创建时间" prop="code">
                <el-input v-model="watchFrom.createTime" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item>
                <el-table
                  :data="watchFrom.deviceInspectionStandardContend"
                  height="250"
                  border
                  style="width: 100%"
                >
                  <el-table-column type="index" label="序号" width="50" align="center">
                  </el-table-column>
                  <el-table-column prop="content" label="标准内容" align="center">
                  </el-table-column>
                </el-table>
              </el-form-item>
            </el-col>
             <el-col :span="24">
              <h6>
                巡检标准（填写）

              </h6>
            </el-col>
            <el-col :span="24">
              <el-form-item prop="InspectionStatus">
                <el-table :data="watchFrom.deviceInspectStandardReadings" border style="width: 100%">
                  <el-table-column type="index" label="序号" width="50"> </el-table-column>
                  <el-table-column prop="name" label="巡检项名称"> </el-table-column>
                  <el-table-column prop="valueRangeMin" label="参考下线"> </el-table-column>
                  <el-table-column prop="valueRangeMax" label="参考上线"> </el-table-column>
                  <el-table-column prop="valueDefault" label="参考标准"> </el-table-column>

                </el-table>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="备注" prop="description">
                <el-input
                 disabled
                  type="textarea"
                  placeholder="请输入 备注"
                  v-model="watchFrom.description"
                  maxlength="200"
                ></el-input>
              </el-form-item>
            </el-col>

          </el-row>
        </el-form>
      </template>
    </hr-dialog>
    <!-- 编辑 -->
    <hr-dialog
      width="65%"
      title="编辑标准"
      v-if="updateDialogVisable"
      :visible.sync="updateDialogVisable"
      :handleClose="handleClose"
    >
      <template slot="body">
        <el-form ref="updateRef" :rules="addStandardRules" :model="updateFrom" label-width="80px">
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="项目名称" prop="projectId">
                <el-select v-model="updateFrom.projectId" placeholder="请选择" style="width:100%">
                  <el-option
                    v-for="item in projectList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="标准名称" prop="name">
                <el-input v-model="updateFrom.name" maxlength="20" placeholder="请输入 标准名称" show-word-limit></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="可选操作" prop="optionalOperationsList">
                <el-select
                  v-model="updateFrom.optionalOperationsList"
                  placeholder="请选择 可选操作"
                  style="width:100%"
                  multiple
                >
                  <el-option
                    v-for="item in watchOperateList"
                    :key="item.dictKey"
                    :label="item.dictValue"
                    :value="item.dictKey"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="巡检标准" prop="standard">
                <el-input type="textarea" placeholder="请输入 巡检标准" v-model="updateFrom.standard" rows="6"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <h6>
                巡检标准（填写）
                <el-button type="primary" icon="el-icon-plus" size="small" @click="addInspect">
                  新 增</el-button
                >
              </h6>
            </el-col>
            <el-col :span="24">
              <el-form-item prop="InspectionStatus">
                <el-table :data="updateFrom.deviceInspectStandardReadings" border style="width: 100%">
                  <el-table-column type="index" label="序号" width="50"> </el-table-column>
                  <el-table-column prop="name" label="巡检项名称"> </el-table-column>
                  <el-table-column prop="valueRangeMin" label="参考下线"> </el-table-column>
                  <el-table-column prop="valueRangeMax" label="参考上线"> </el-table-column>
                  <el-table-column prop="valueDefault" label="参考标准"> </el-table-column>
                  <el-table-column label="操作" align="center" width="150">
                    <template slot-scope="scope">
                      <el-button
                        type="text"
                        size="small"
                        icon="el-icon-edit"
                        @click="editInspectItem(scope)"
                        >编辑
                      </el-button>
                      <el-button
                        type="text"
                        size="small"
                        icon="el-icon-delete"

                        @click="removeInspectItem(updateFrom.deviceInspectStandardReadings,scope)"
                        >删除
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="备注" prop="description">
                <el-input
                  type="textarea"
                  v-model="updateFrom.description"
                  placeholder="请输入 备注"
                  maxlength="200"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <div style="float:right">
                <el-button
                size="small"
                  type="primary"
                  icon="el-icon-circle-check"
                  @click="updateSubmitStandard"
                  style="margin-right: 20px"
                  >修改</el-button
                >
                <el-button size="small" icon="el-icon-circle-close" @click="UpdateSubmitStandardClose"
                  >取消</el-button
                >
              </div>
            </el-col>
          </el-row>
        </el-form>
        <addInspectItem
          v-if="addInspectItemDialog"
          :operatorModle='inspectItemModle'
          :visible.sync="addInspectItemDialog"
          :dataList="updateFrom.deviceInspectStandardReadings"
          :row="inspectItemListRow"
          @getInpectItem="getInpectItem"
        />
      </template>
    </hr-dialog>
    <!-- 新增设备维保记录对话框 -->

    <hr-dialog
      title="已关联设备"
      v-if="relateDeviceFlag"
      :visible.sync="relateDeviceFlag"
      width="80%"
      :handleClose="handleClose"
    >
      <template slot="body">
        <relateDevice
          :isShowMenuLeft="isShowMenuLeft"
          :standardId="standardId"
          :projectId="projectId"
        ></relateDevice>
      </template>
    </hr-dialog>
  </div>
</template>

<script>
import {
  getList,
  getBisDictData,
  add,
  getDetail,
  update,
  standardRemove,
  forbidStandard,
} from '@/api/crmedical/device/deviceInspectionStandard';
import { getProjectList } from '@/api/crmedical/project/project';
import Mtextarea from '@/components/textArea/index.vue';
import relateDevice from '@/components/device/deviceRelation/deviceRelation';
import searchFromShow from '@/components/search-form-show/index';
import addInspectItem from './addInspectItem.vue';

export default {
  components: { Mtextarea, relateDevice, searchFromShow, addInspectItem },
  data() {
    let operateStatusValidator = (rule, value, callback) => {
      console.log('可选操作自定义验证', value);
      // let reg = /^([0-9]|[1-9][0-9]{0,8})(\.[1-9]|\.[0-9]{1,2})?$/;
      // console.log('判断结果', reg.test(value));
      if (value.length >= 2 && value.length <= 3) {
        callback();
      } else {
        callback(new Error('可选操作只能2-3个'));
      }
    };
    return {
      inspectItemListRow:{},
      addInspectItemDialog: false,
      searchBoxFlag: true,
      searchHeight: '',
      addStandardRules: {
        projectId: [{ required: true, message: '部门不能为空！', trigger: 'blur' }],
        name: [{ required: true, message: '标准名称不能为空！', trigger: 'blur' }],
        optionalOperationsList: [
          { required: true, message: '可选操作不能为空！', trigger: 'blur' },
          {
            required: true,
            validator: operateStatusValidator,
            trigger: 'change',
          },
        ],
        // standard: [{ required: true, message: '标准不能为空！', trigger: 'blur' }],
      },
      isShowMenuLeft: false,
      projectId: '',
      standardId: '', //标准id
      relateDeviceFlag: false, //关联设备对话框
      updateOrigin: [], //修改的原始副本
      updateDialogVisable: false, //编辑对话框
      updateFrom: {},
      watchOperateList: [],
      watchDialogVisable: false, //查看对话框
      watchFrom: {
        projectId: '',
        name: '',
        standard: '',
        optionalOperationsList: [],
        deviceInspectStandardReadings: [],
      },
      deviceInspectionStandardContend: [],
      operateList: [],
      standardList: [],
      projectList: [],
      statusList: [
        { name: '启用', id: 1 },
        { name: '停用', id: 0 },
      ],
      addDialogVisable: false,
      option: {
        index: true,
        // selection: true,
        // reserveSelection:true,
        indexLabel: '序号',
        page: true,
        align: 'left',
        menuAlign: 'center',
        addBtn: false,
        editBtn: false,
        delBtn: false,
        border: true,
        height: 'auto',
        column: [
          {
            label: '项目名称',
            prop: 'projectName',
          },
          {
            label: '标准名称',
            prop: 'name',
          },
          {
            label: '创建人',
            prop: 'realName',
          },
          {
            label: '创建时间',
            prop: 'createTime',
          },
          {
            label: '状态',
            prop: 'status',
            dicData: [
              { name: '启用', id: 1 },
              { name: '停用', id: 0 },
            ],
            props: {
              value: 'id',
              label: 'name',
            },
          },
        ],
      },
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      loading: false,
      selectForm: {},
      form: {
        projectId: '',
        name: '',
        standard: '',
        optionalOperationsList: [],
        deviceInspectStandardReadings: [],
      },
      inspectItemModle:'add'
    };
  },
  created() {
    this.initData();
  },
  mounted() {
    this.calcHeight();
  },
  methods: {
    //删除巡检
    removeInspectItem(objArry,scope){
      objArry.splice(scope.$index,1)
      console.log("删除",scope)
    },
    editInspectItem(scope){
     this.inspectItemListRow = {}
     this.inspectItemListRow =scope.row
     this.inspectItemModle = 'view'
     this.addInspectItemDialog = true
    },
    getInpectItem() {},
    addInspect() {
      this.inspectItemModle = 'add'
      this.addInspectItemDialog = true;
    },
    calcHeight() {
      this.searchHeight = this.$refs.searchFormRef.$el.clientHeight;
      this.option.height = this.bodyHeight - 340;
    },
    UpdateSubmitStandardClose() {
      this.updateDialogVisable = false;
    },
    forbidStandard(row) {
      this.$confirm('此操作将停用该标准, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        forbidStandard({ id: row.id, status: 0 }).then((res) => {
          this.$message({
            type: 'success',
            message: '停用成功!',
          });
          this.onLoad();
        });
      });
    },
    removeStandard(id) {
      this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        standardRemove(id).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!',
          });
          this.onLoad();
        });
      });
    },
    handleClose() {
      this.tool.clearObject(this.form)
       this.tool.clearObject(this.watchFrom)
        this.tool.clearObject(this.updateFrom)

      // this.watchDialogVisable = false;
      // this.updateDialogVisable = false;
      // this.addDialogVisable = false;
      this.relateDeviceFlag = false;
    },
    search() {
      this.page.currentPage = 1;
      this.onLoad();
    },
    searchClear() {
      this.selectForm.name = '';
      this.selectForm.status = '';
    },

    async copyStandard(row) {
      await getDetail({ id: row.id }).then(({ data }) => {
        this.form = data;
        getBisDictData({
          code: 'project_device_inspect_operation',
          projectId: this.form.projectId,
        }).then((res) => {
          this.watchOperateList = res.data;
        });
        this.form.realName = row.realName;
        this.form.optionalOperationsList = this.form.optionalOperations.split(',');
      });
      let arr = this.form.deviceInspectionStandardContend;

      let arrContent = [];
      arr.forEach((item) => {
        arrContent.push(item.content);
      });

      this.$set(this.form, 'standard', arrContent.join('\n'));

      this.addDialogVisable = true;
    },
    //关联设备
    relateDevice(row) {
      console.log(row);
      this.isShowMenuLeft = row.status == 1 ? true : false;
      this.relateDeviceFlag = true;
      this.standardId = row.id;
      this.projectId = row.projectId;
    },
    //项目切换操作数据发生改变
    projectIdChange(val) {
      getBisDictData({ code: 'project_device_inspect_operation', projectId: val }).then((res) => {
        this.watchOperateList = res.data;
      });
    },
    //编辑提交
    updateSubmitStandard() {
      console.log('updateForm', this.updateFrom);
      this.updateFrom.optionalOperations = this.updateFrom.optionalOperationsList.toString();
      let reg = /^[ ]*$/;
      let standardFlag = 1;
      let arry = [];
      arry = this.updateFrom.standard.split('\n');
      if (this.updateOrigin.join('\n') == this.updateFrom.standard) {
        standardFlag = 0;
        console.log('没有进行修改');
      } else {
        console.log('进行了修改');
      }
      let decorateList = [];
      for (let i = 0; i < arry.length; i++) {
        for (let j = i + 1; j < arry.length; j++) {
          if (arry[i] == arry[j]) {
            this.$message.error('标准不能出现重复！');
            return;
          }
        }
      }
      try {
        arry.forEach((element, index) => {
          if (element && !reg.test(element)) {
            if (element.length > 0 && element.length > 200) {
              throw new Error('单条标准不能超过200个字符');
            }
            let obj = {};
            obj.sortNum = index + 1;
            obj.content = element;
            decorateList.push(obj);
          }
        });
        // if (decorateList.length <= 0) {
        //   this.$message.error('标准至少要有一条！');
        //   return;
        // }
        this.$refs['updateRef'].validate((valid) => {
          if (valid) {
            update({
              standardFlag: standardFlag,
              id: this.updateFrom.id,
              projectId: this.updateFrom.projectId,
              name: this.updateFrom.name,
              optionalOperations: this.updateFrom.optionalOperations.toString(),
              deviceInspectionStandardContend: decorateList,
              description: this.updateFrom.description,
              deviceInspectStandardReadings:this.updateFrom.deviceInspectStandardReadings
            }).then(() => {
              this.$message({
                showClose: true,
                message: '修改成功',
                type: 'success',
              });
              this.onLoad();
              this.updateDialogVisable = false;
            });
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      } catch {
        this.$message.error('单条标准不能超过200个字符');
      }
    },
    //编辑数据回显处理
    async updateStandard(row) {
      await getDetail({ id: row.id }).then(({ data }) => {
        this.updateFrom = data;
        getBisDictData({
          code: 'project_device_inspect_operation',
          projectId: this.updateFrom.projectId,
        }).then((res) => {
          this.watchOperateList = res.data;
        });
        this.updateFrom.realName = row.realName;
        this.$set(
          this.updateFrom,
          'optionalOperationsList',
          this.updateFrom.optionalOperations.split(',')
        );
      });
      let arr = this.updateFrom.deviceInspectionStandardContend;

      let arrContent = [];
      arr.forEach((item) => {
        arrContent.push(item.content);
      });
      this.updateOrigin = arrContent;
      this.$set(this.updateFrom, 'standard', arrContent.join('\n'));
      // this.updateFrom.standard = arrContent.join('\n')
      this.updateDialogVisable = true;
    },
    //详情数据回显
    checkStandard(row) {
      this.watchDialogVisable = true;

      getDetail({ id: row.id }).then(({ data }) => {
        this.watchFrom = data;
        getBisDictData({
          code: 'project_device_inspect_operation',
          projectId: this.watchFrom.projectId,
        }).then((res) => {
          this.watchOperateList = res.data;
        });
        this.watchFrom.realName = row.realName;
        this.watchFrom.optionalOperations = this.watchFrom.optionalOperations.split(',');
      });
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    //新增
    addRecord() {
      this.addDialogVisable = true;
      this.tool.clearObject(this.form, 'projectId');
      this.$set(this.form,'projectId',this.selectForm.projectId)



      getBisDictData({
        code: 'project_device_inspect_operation',
        projectId: this.form.projectId,
      }).then((res) => {
        this.watchOperateList = res.data;
      });
    },
    initData() {
      getProjectList().then((res) => {
        this.projectList = res.data;
        if (this.projectList.length > 0) {
          this.$set(this.selectForm, 'projectId', this.projectList[0].id);
          this.onLoad();
        }
      });
    },
    onLoad(page) {
      page = page || this.page;
      if (this.selectForm.projectId) {
        this.loading = true;
        getList(
          Object.assign(
            {},
            { current: this.page.currentPage, size: this.page.pageSize },
            this.selectForm
          )
        )
          .then(({ data }) => {
            this.standardList = data.records;
            this.page.total = data.total;
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    closeSubmitStandard() {
      this.addDialogVisable = false;
    },
    AddSubmitStandard() {
      let reg = /^[ ]*$/;
      this.deviceInspectionStandardContend = [];
      let arry = [];
      arry = this.form.standard.split('\n'); //
      let decorateList = [];
      let sortNum = 0;
      for (let i = 0; i < arry.length; i++) {
        for (let j = i + 1; j < arry.length; j++) {
          if (arry[i] == arry[j]) {
            this.$message.error('标准不能出现重复！');
            return;
          }
        }
      }
      try {
        arry.forEach((element, index) => {
          if (element && !reg.test(element)) {
            if (element.length > 0 && element.length > 200) {
              throw new Error('单条标准不能超过200个字符');
            }
            let obj = {};
            obj.sortNum = sortNum;
            obj.content = element;
            decorateList.push(obj);
            sortNum++;
          }
        });
        // if (decorateList.length <= 0) {
        //   this.$message.error('标准至少要有一条！');
        //   return;
        // }
        this.form.optionalOperations = this.form.optionalOperationsList.toString();

        this.deviceInspectionStandardContend = decorateList;
        this.$refs['addRef'].validate((valid) => {
          if (valid) {
            add(
              Object.assign({}, this.form, {
                deviceInspectionStandardContend: this.deviceInspectionStandardContend,
              })
            ).then(() => {
              this.$message({
                showClose: true,
                message: '添加成功',
                type: 'success',
              });
              this.addDialogVisable = false;
              this.onLoad();
            });
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      } catch {
        this.$message.error('单条标准不能超过200个字符！');
      }
    },
  },
};
</script>

<style></style>
